import { render, staticRenderFns } from "./ChatContactMessage.vue?vue&type=template&id=2a3951f0&scoped=true&lang=pug&"
import script from "./ChatContactMessage.vue?vue&type=script&lang=js&"
export * from "./ChatContactMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatContactMessage.vue?vue&type=style&index=0&id=2a3951f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3951f0",
  null
  
)

export default component.exports